import React, { useRef } from 'react';
import Icon from '@/components/atoms/icon/icon';
import RiveAnimation from '@/components/atoms/rive-animation/rive-animation';
import Typography from '@/components/atoms/typography/typography';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import Row from '@/components/utilities/row/row';
import useIsInView from '@/libraries/hooks/use-is-in-view';
import { useWindowSize } from '@/libraries/hooks/use-window-size';
import styles from './animated-banner.module.scss';

export interface AnimatedBannerProps extends ModuleWrapperProps {
  /** The text to show */
  text: string;
}

const AnimatedBanner = ({ text, ...rest }: AnimatedBannerProps) => {
  const isLaptop = useWindowSize('laptop');
  const componentRef = useRef<HTMLDivElement>(null);
  const { isInView } = useIsInView(componentRef, {
    rootMargin: '0px',
    threshold: 0.5,
  });

  return (
    <ModuleWrapper ref={componentRef} {...rest} className={styles.component}>
      <div className={styles.planeLeft}>
        <RiveAnimation name="SlideInLeft" play={isInView} />
      </div>

      <div className={styles.planeBottom}>
        <RiveAnimation name="SlideInBottom" play={isInView} />
      </div>

      <div className={styles.planeTop}>
        <RiveAnimation name="SlideInTop" play={isInView} />
      </div>

      <Container>
        <Row>
          <Column className={styles.column}>
            <div className={styles.content}>
              <Icon className={styles.icon} name="Travelheart" size={40} />

              {text && (
                <Typography
                  className={styles.text}
                  tagStyle={isLaptop ? 'headingLarge' : 'headingMedium'}
                >
                  {text}
                </Typography>
              )}
            </div>
          </Column>
        </Row>
      </Container>
    </ModuleWrapper>
  );
};

AnimatedBanner.displayName = 'AnimatedBanner';

export default AnimatedBanner;
